<template>
  <!--==================
    Forgot password component used in user login page
    ===============-->
  <div class="container-login100">
    <div class="wrap-login">
      <div class="wrap-login100">
        <div v-if="errorMessage" class="text-center text-danger mb-5 col">
          <em>{{ errorMessage }}</em>
        </div>
        <div v-if="successMessage" class="text-center text-success mb-5 col">
          <em>password reset send successfull, open your email inbox or spam and click "reset password" link.</em>
        </div>

        <form @submit.prevent="submitFormData" class="login100-form validate-form">
          <div class="login100-form-logo">
            <img src="@/assets/images/logo.png" />
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              type="email"
              v-model="form.username"
              placeholder="Email"
              :disabled="submitForm"
              @input="$v.form.username.$touch()"
            />
            <i class="zmdi zmdi-account focus-input"></i>
          </div>
          <span class="text-danger" v-if="$v.form.username.$dirty && !$v.form.username.required">
            &nbsp; Email field is required
          </span>
          <div class="login100-form-links">
            <a class="txt1 m-b-20" href="/">Back to Login?</a>
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" :disabled="$v.form.$invalid">
              <span v-if="!submitForm">Submit</span>
              <span v-if="submitForm" class="spinner-border spinner-border-sm" role="status"></span>
              <span v-if="submitForm" class="ml-2">Submitting...</span>
            </button>
          </div>
        </form>
      </div>
      <p>
        &copy; {{ footerYear }} Safari-Tz | By
        <a class="txt1" href="http://www.isaxstar.co.tz" target="_blank">Isaxstar Developer</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@import "@/assets/vendor/login-v3/fonts/iconic/css/material-design-iconic-font.min.css";
@import "@/assets/vendor/login-v3/css/util.css";
@import "@/assets/vendor/login-v3/css/main.css";
</style>

<script>
import $ from "jquery";
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ForgotPassword",

  data() {
    return {
      form: {},
      footerYear: null,
      submitForm: false,
      errorMessage: false,
      successMessage: false,
    };
  },

  mounted() {
    document.title = "Forgot Password";
    this.getFooterYear();
    this.focusInput();
  },

  validations() {
    return {
      form: {
        username: { required },
      },
    };
  },

  methods: {
    getFooterYear() {
      const now = new Date();
      this.footerYear = now.format("yyyy");
    },

    async submitFormData() {
      this.$v.form.$reset();
      this.submitForm = true;
      this.errorMessage = false;

      const url = process.env.VUE_APP_API_URL;
      const emailUrl = process.env.VUE_APP_EMAIL_URL;

      await axios.post(`${url}/auth/forgot-password`, { username: this.form.username }).then(async (res) => {
        if (res.data.statusCode === 404) {
          this.submitForm = false;
          this.errorMessage = res.data.message;
          this.form = {};
        } else {
          // send email
          const data = {
            email: res.data.username,
            token: res.data.token,
          };

          await axios.post(`${emailUrl}/forgot-password`, data).then((res) => {
            this.submitForm = false;
            this.successMessage = true;

            // console.log(res.data);
          });
        }
      });
    },

    focusInput() {
      $(".input100").each(function () {
        $(this).on("blur", function () {
          if ($(this).val().trim() != "") {
            $(this).addClass("has-val");
          } else {
            $(this).removeClass("has-val");
          }
        });
      });
    },
  },
};
</script>
